$(document).ready(function() {

  const $searchInput = $('.js-search-input');
  const $searchResults = $('.js-search-results');
  var searchTerm = $searchInput.val(),
    isSearchPage = false;

  function displaySearchResults(results) {
    var itemHtml = '', productTitle, producthandle,productid, featuredImageUrl, productShortDesc, initVariantId, initVariantAvailable = false, initVariantPrice, initVariantSize, initVariantMonSupply, monthText='Months Supply', totalDays = 0, perDayValue = 0;
    var itemvariant = '',rehtml;
    var finalhtml = '';
     var i = 0;
    $.each(results, function(key, item) {
     
      productTitle = item.title,
      producthandle =item.handle  
      productid = item.id,
      featuredImageUrl = item.primaryImageUrl;
      productShortDesc = item.variants[(item.variants.length - 1)].shortDescription;
      initVariantId = item.variants[(item.variants.length - 1)].variantId;
      initVariantAvailable = item.variants[(item.variants.length - 1)].availableForSale;
      initVariantPrice = (item.variants[(item.variants.length - 1)].price * 1).toFixed(2);
      initVariantSize = item.variants[(item.variants.length - 1)].size;
      initVariantMonSupply = item.variants[(item.variants.length - 1)].monthSupply * 1;
      monthText = initVariantMonSupply == 1 ? 'Month Supply' : 'Months Supply';
      totalDays =  initVariantMonSupply * 30;
      perDayValue = (initVariantPrice / totalDays).toFixed(2);
      itemvariant = "";

      let buttonText = initVariantAvailable ? 'Add to Cart' : 'Out of Stock';
      let buttonData = initVariantAvailable ? 'data-item-add-to-cart' : 'disabled';

      itemHtml = '<div class="grid-view-item product-card product-card--grid">' +
      '<div class="mainbox">'+
        '<div class="h4 grid-view-item__title product-card__title js-product-card__title producthover">' +
          '<a href="https://smartq.pureforyou.com/products/'+ initVariantId +'/'+producthandle+'">'+ productTitle +'</a>' +
        '</div>' +
        '<div class="proshortdes" style="color:#fff;">'+ productShortDesc +'</div>' +
        '<div class="product-card__image-with-placeholder-wrapper procardmain" data-image-with-placeholder-wrapper>' +
          '<a href="https://smartq.pureforyou.com/products/'+ initVariantId +'/'+producthandle+'" class="grid-view-item__link grid-view-item__image-container full-width-link"><span class="visually-hidden">'+ productTitle +'</span></a>' +
          '<div class="grid-view-item__image-wrapper product-card__image-wrapper js"><img class="grid-view-item__image lazyload" data-src="'+ featuredImageUrl +'" alt="primary"></div>' +
        '</div>' +
        '<div class="proconwarp">' +
          '<div class="h4 grid-view-item__title product-card__title js-product-card__title procardmain">' +
            '<a data-id="" href="https://smartq.pureforyou.com/products/'+ initVariantId +'/'+producthandle+'"><span class="allcol">'+ productTitle +'</span></a>' +
          '</div>' +
          '<div class="prodes-odd">'+ productShortDesc +'</div>' +
          '<div id="productCardVariant-'+ initVariantId +'" class="product-card__details js-product-card-details-'+ productid +' active">' +
            '<div class="product-card__variant-det size">'+ initVariantSize +'</div>' +
            '<div class="product-card__variant-det supply">' +
              '<span class="variant-month-supply-box">'+ initVariantMonSupply +'</span><span class="month-text">'+ monthText +'</span><div class="perdayval">'+ perDayValue+'/ day  </div>' +
            '</div>' +
          '</div>' +
          '<div class="price price--listing price--listing-search js-price-listing-'+ productid +' price--listing-collection">' +
            '<div class="price__regular"><span class="price-item price-item--regular">$'+ initVariantPrice +'</span></div>' +
          '</div><ul id="vari-'+ productid +'" class="varientdd" data-btn-text="Out of Stock"  data-form="plp-form-'+productid+'" data-varid="'+productid+'">';

          let itemVariantsAsc = (item.variants).reverse();
          $.each( itemVariantsAsc, function(key, variant) {
            if(variant.monthSupply==1){
            var mtxt = "Month";
            }
            else {
              var mtxt = "Months";
            }
            itemvariant = itemvariant+'<li data-proid="'+variant.variantId+'" data-available="'+ variant.availableForSale +'" data-size="'+variant.size+'" data-month-supply="'+ variant.monthSupply +'" data-price="'+ variant.price +'">'+variant.size+'<br>'+ variant.monthSupply +' '+mtxt+' Supply <br> $'+ variant.price +'</li>';
          });
          rehtml = '</ul><div class="pdbtn"><a href="https://smartq.pureforyou.com/products/'+ initVariantId +'/'+producthandle+'" class="pbbtnlink">Product Details</a></div>' +
        '</div>' +
      '</div>'+
      '</div>';
      finalhtml = itemHtml+itemvariant+rehtml;

      var detail = document.getElementById("searchPageResults");
      var descriptionNode = document.createElement("li");
      descriptionNode.className = "grid__item small--one-half medium-up--one-third";
      descriptionNode.innerHTML = finalhtml;
      detail.appendChild(descriptionNode);
    });
  };

  function getSearchResults(term) {
    //alert("call");
   
      $.getJSON('https://suggest.dxpapi.com/api/v2/suggest/?account_id=6664&auth_key=1fms633dyv3061et&domain_key=atrium_en_pureforyou&request_id=8944895679661&_br_uid_2=uid%3D8548545967532%3Av%3D11.8%3Ats%3D1650530465459%3Ahc%3D604&url=www.bloomique.com&ref_url=www.bloomique.com&q='+term+'&request_type=suggest&catalog_views=atrium_en_pureforyou', function(result){
        //console.log(result);
   //console.log(result.suggestionGroups[0]["querySuggestions"]);
        $searchResults.empty().hide();
     var htmlres = '';
     var qsuggcount = 0; 
       var querysuggstr = "";  
    let secall = true;
        if($searchInput.is(':focus')) {
          if(secall){
            //console.log(secall);
            htmlres = "<div class=searchwrap><ul class=suggestiongroups>";
        $.each(result.suggestionGroups[0]["searchSuggestions"], function(key, val) {
          //let prourl = getproducturl(val.pid);
          //console.log(prourl)
          //console.log(val);
            htmlres += '<li class="predictive-search-item" role="option"><a data-productid="'+ val.pid +'" href="#" class="predictive-search-item__link">' +
            '<span class="predictive-search__column predictive-search__column--image"><img class="predictive-search-item__image" alt="'+ val.title +'" src="'+ val.thumb_image +'" width="71" ></span>' +
            '<span class="predictive-search__column predictive-search__column--content predictive-search__column--center">' +
            '<span class="predictive-search-item__title"><span class="predictive-search-item__title-text">'+ val.title +'</span></span>' +
            '</span></a> </li>';
        });
           htmlres +="</ul><ul class=querysuggestion>"; 
             
            $.each(result.suggestionGroups[0]["querySuggestions"] ,function(key, val) {
          if(qsuggcount < 15){
           querysuggstr = val.query; 
            querysuggstr = querysuggstr.replace(/ /g, '+');
            htmlres += '<li class="predictive-search-item" role="option"><a href="https://smartq.pureforyou.com/search?q='+ querysuggstr +'" class="predictive-search-item__link">'+
            '<span class="predictive-search-item__title"><span class="predictive-search-item__title-text">'+ val.displayText +'</span>' +'</a> </li>';
          }
              qsuggcount++;
        });  

            htmlres +="</ul></div>"
            
           $searchResults.append(htmlres);

        setTimeout(function(){
          $searchResults.show();
        }, 300);
   //console.log(result.suggestionGroups[0]["searchSuggestions"]);  
            secall = false;
          }
        }
      });
    // $.ajax({
    //   headers: { 'Content-Type': 'application/json', 'Accepts': 'application/json; text/html' },
    //   type: 'GET',
    //   url: 'https://smartq.pureforyou.com/api/product/search?term='+term,
    //   success: function( data ) {
    //     $searchResults.empty();
    //     var htmlResult = '';

    //     if($searchInput.is(':focus')) {
    //     $.each(data.data, function(key, val) {
    //       console.log(val);
    //         htmlResult = htmlResult + '<li class="predictive-search-item" role="option"><a href="https://smartq.pureforyou.com/products/'+ val.variants[0].variantId +'/'+val.handle+'" class="predictive-search-item__link">' +
    //         '<span class="predictive-search__column predictive-search__column--image"><img class="predictive-search-item__image" alt="'+ val.title +'" src="'+ val.primaryImageUrl +'" width="44" ></span>' +
    //         '<span class="predictive-search__column predictive-search__column--content predictive-search__column--center">' +
    //         '<span class="predictive-search-item__title"><span class="predictive-search-item__title-text">'+ val.title +'</span></span>' +
    //         '</span></a> </li>';
    //     });
    //     $searchResults.append(htmlResult);

    //     setTimeout(function(){
    //       $searchResults.show();
    //     }, 300);
    //     }

    //     if(isSearchPage) {
    //       $('.js-search-title').text(data.data.length+' results for "'+term+'"');
    //       displaySearchResults(data.data);
    //     }
    //   },
    //   error: function (xhr, status) {
    //       console.log("error");
    //       console.log({xhr},{status});
    //   }
    // });

    
  }


 $('.predictive-search-wrapper').on('click', '.predictive-search-item__link', function(){
 let pid = $(this).attr("data-productid");
   console.log(pid);
   let  urlstr ="";
    $.ajax({
    headers: { 'Content-Type': 'application/json', 'Accepts': 'application/json; text/html' },
    type: 'GET',
     url: 'https://smartq.pureforyou.com/api/product/search?term='+pid,  
     success: function( data ) {
     $.each(data.data, function(key, val) {       
       urlstr = "https://smartq.pureforyou.com/products/"+val.variants[0].variantId +"/"+val.handle;
      window.location = urlstr;
     });
     }
    });
 })
 


  $(".js-search-form").submit(function(event) {
    let searchTerm = $searchInput.val();
    event.preventDefault();
    if(searchTerm != '') {      
      //getSearchResults(searchTerm);
      window.location.href="https://smartq.pureforyou.com/search?q="+searchTerm;
    }
  });


  $searchInput.off('keyup').on('keyup', function(evt) {
    let searchTerm = $searchInput.val();
    evt.stopImmediatePropagation();
    let numChar = 3;
    if(searchTerm.length >= numChar) {
      $searchResults.remove('active');
      getSearchResults(searchTerm);
      return false;
    }
    else {
      $searchResults.empty();
    }
  });

  if($('body').hasClass('template-search')) {
    if(searchTerm != '') {
      isSearchPage = true;
     // getSearchResults(searchTerm);
    }

    $('#searchPageResults').on('click', '.varientdd li', function(){
      let id = $(this).closest('.varientdd').attr('data-varid');
      let variantSize = $(this).attr('data-size');
      let variantMoSupply = $(this).attr('data-month-supply') * 1;
      let variantMonthText = variantMoSupply == 1 ? 'Month Supply' : 'Months Supply';
      let variantPrice = $(this).attr('data-price') * 1;
      let variantPerDayVal = (variantPrice / (variantMoSupply * 30)).toFixed(2);
      $('.js-product-card-details-'+id+' .product-card__variant-det.size').text(variantSize);
      $('.js-product-card-details-'+id+' .variant-month-supply-box').text(variantMoSupply);
      $('.js-product-card-details-'+id+' .month-text').text(variantMonthText);
      $('.js-product-card-details-'+id+' .perdayval').text(variantPerDayVal+'/day');
      $('.js-price-listing-'+id+' .price-item--regular').text('$'+variantPrice.toFixed(2));

    });
  }

  $searchResults.on('mouseover', function() {
    $(this).show();
  }).mouseout(function() {
    $(this).hide();
  });
});

/*!
 * Pseudo Select v1.0.3
 * Copyright 2018-2019 Isman Fromes
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */
!function(e){var t=e("body");function i(t){var i=e(".toggle-button").outerHeight(!0);t.parent().toggleClass("active"),t.parent().hasClass("active")?t.parent().children("ul").css("top",i):t.parent().children("ul").css("top",i-10)}e.fn.pseudoSelect=function(t){var s=this;this.addClass("pseudo-select-list"),s.wrap('<div class="pseudo-select"></div>');var a=s.parent(".pseudo-select");if(s.children("li:first-child").addClass("active"),s.children("li.active").eq(0))l=s.data("btn-text");else var l=e.parseHTML(s.children("li.active").text());if(a.prepend('<button class="toggle-button button">'+l+"</button>"),s.children("li:first-child").data("btnText",l),t){if(t.breaking){e(window).resize(function(){var e=window.innerWidth;e>t.breaking?(a.addClass("break"),a.children("ul").css("top","")):(a.removeClass("break"),a.removeClass("active"))}),e(window).trigger("resize")}if(t.closeOnValueSelected)s.children("li").on("click",function(e){s.parent().hasClass("break")||i(s)});if(t.hasCheckbox)s.addClass("checkbox"),s.children("li").prepend("<span></span>")}},t.on("click",".pseudo-select .toggle-button",function(){var t=e(this);t.parent().hasClass("active")||e(".pseudo-select").removeClass("active"),i(t)}),t.on("click",".pseudo-select-list li",function(t){t.preventDefault(),e(this).parent().children("li").removeClass("active"),e(this).addClass("active");var i=e(this).parents(".pseudo-select").children(".button"),s=e(this).parent().children("li:first-child").html(),a=e(this).html(),l=e(this).parents().children("li").data("btn-text");a!==s?i.html(a):i.html(l)})}(jQuery);
$(window).on("load", function (e) {

  $("#searchPageResults .varientdd").each(function(){
    var fsstr = $(this).children(":first").html();
    $(this).attr("data-btn-text",fsstr);
    var varid = $(this).attr("data-varid");
    $('#vari-'+varid).pseudoSelect({
      closeOnValueSelected: true
    });
  });

});
